import { render } from "./MWayHome.vue?vue&type=template&id=3e29fb84&scoped=true"
import script from "./MWayHome.vue?vue&type=script&lang=js"
export * from "./MWayHome.vue?vue&type=script&lang=js"

import "./MWayHome.vue?vue&type=style&index=0&id=3e29fb84&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3e29fb84"]])

export default __exports__